module.exports = "<div ui-view></div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/quoteandbind/mfp/views/mfp-wizard.html
// module id = 634
// module chunks = 0